module.exports = __webpack_public_path__ + "img/modalAlert.3d10b7c5.svg";